import axios from "axios";

// Post In and get Attende Details
export const accesoInvitadoConferencia = (event_id, invitado_id) => {
  /*
  try {
    return axios.get("/api/eventos/"+event_id+"/in/"+invitado_id);
  } catch (error) {
    console.error(error)
  }
  */
  return axios.get("/api/eventos/"+event_id+"/accesoconferencias/"+invitado_id);
};

// Post Out and get Attende Details
export const postOut = (event_id, invitado_id) => {
    try {
      return axios.get("/api/eventos/"+event_id+"/out/"+invitado_id);
    } catch (error) {
      console.error(error)
    }
  };
  